module.exports = __webpack_public_path__ + "static/media/tornado.aaae5730.svg";